module.exports = "/images/search.svg?ccd57cd16ccd086a91198e5185ddfa43";